module.exports = __webpack_public_path__ + "static/media/Carta-compromiso-de-entrega-de-Certificado.ff17a43a.docx";